// Institute of Design and Innovation (email idi@unm.edu). //

import axios, { AxiosRequestConfig } from 'axios'
import cookie from 'js-cookie'
import SessionService from '@/common/sessionService'

/**
 * The Axios Client to be configured
 */
const httpClient = axios.create({
  baseURL: '/api/'
})

/**
 * Interceptor to ensure a valid token is sent with the request
 */
httpClient.interceptors.request.use((config: AxiosRequestConfig) => {
  // Ignores the refresh route
  if (config.url === 'authentication/refresh' && config.method === 'get') {
    return config
  }

  const accessExp = cookie.get('access_exp')
  const timeToExpiration = accessExp ? parseInt(accessExp) : 0

  if (timeToExpiration <= Date.now()) {
    // If expired, refresh tokens before making a request
    return new Promise((resolve, reject) => {
      SessionService.initializeSession().then(() => {
        resolve(config)
      }, err => {
        reject(err)
      })
    })
  } else {
    return config
  }
}, (error) => {
  return Promise.reject(error)
})

export default httpClient
